/* MOBILE VIEWS */

html, body {
    overscroll-behavior: none;
}

body {
    font-size: 1rem;
}

.mobile-show-scrollbar {
    scrollbar-width: auto !important;
}


/* .bp6-tab-list {
    scrollbar-width: none !important;
} */

/* .bp6-drawer-header {
    min-height: 0px;
    height: 35px;
    padding-left: 12px;
} */

/* BLUEPRINT LARGE COMPONENT SETTERS */

/* Dialog */
.bp6-dialog {
    max-height: 28rem;
    max-width: 95%;
}

.bp6-dialog-header > .bp6-heading {
    font-size: 1.1rem;
}

/* Button */
.bp6-button {
    min-height: 2.5rem;
    min-width: 2.5rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
}

/* Tag */
.bp6-tag {
    font-size: 1rem;
    line-height: 1.5rem;
    min-height: 2rem;
    min-width: 2rem;
    padding: 0.5rem 1rem;
}

/* Input & Input Group */
.bp6-input,
.bp6-file-upload-input,
.bp6-input-group {
    font-size: 1rem;
    min-height: 2.5rem;
    line-height: 2.5rem;
}

/* HTML Select */
.bp6-html-select > select {
    font-size: 1rem;
    height: 2.5rem;
    line-height: 2.5rem;
}

.bp6-html-select > .bp6-icon {
    right: 12px;
    top: 12px;
}

/* File Input */
.bp6-file-input {
    height: 2.5rem;
}

/* File Upload Button */
.bp6-file-upload-input::after {
    min-height: 30px;
    min-width: 30px;
    line-height: 30px;
    margin: 5px;
    width: 85px;
}


.global-search > .bp6-input-group > .bp6-input {
    font-size: 1.25rem;
}


/* Checkbox */
.bp6-checkbox .bp6-control-indicator {
    width: 1.5rem;
    height: 1.5rem;
}
.bp6-checkbox .bp6-control-label {
    font-size: 1rem;
}

/* Radio */
.bp6-radio .bp6-control-indicator {
    width: 1.5rem;
    height: 1.5rem;
}
.bp6-radio .bp6-control-label {
    font-size: 1rem;
}

/* Switch */
.bp6-switch {
    font-size: 1rem;
    padding: 0.5rem 1rem;
}

/* HTML Select */
.bp6-html-select {
    font-size: 1rem;
    height: 2.5rem;
    line-height: 2.5rem;
}

/* Slider */
.bp6-slider .bp6-slider-handle {
    width: 1.5rem;
    height: 1.5rem;
}

/* Spinner */
.bp6-spinner {
    width: 2.5rem;
    height: 2.5rem;
}

/* Callout */
.bp6-callout {
    font-size: 1rem;
    padding: 1.5rem;
}

/* Menu & Menu Items */
.bp6-menu {
    font-size: 1rem;
}

.bp6-menu-item {
    min-height: 2.5rem;
    font-size: 1rem;
    padding: 0.5rem;
}

/* Tabs */
.bp6-tabs .bp6-tab {
    font-size: 1rem;
    padding: 0.5rem 1rem;
}

/* Navbar */
.bp6-navbar {
    font-size: 1rem;
    padding: 0.5rem 1rem;
}

/* MultiSelect Tag Input (ensuring large sizing) */

.bp6-tag-input-values > .bp6-tag {
    font-size: 14px;
    min-height: 30px; 
    min-width: 30px;
    line-height: 20px; 
    padding: 5px 10px;
}

    /* Centers the Radio indicators as they are misaligned with sizes */
    .bp6-control .bp6-control-indicator::before {
        width: 1.5rem;
        height: 1.5rem;
    }

/* END OF BLUEPRINT LARGE COMPONENT SETTERS */

/** 1px offset for incrementing buttons on Numeric Input only affects mobile/tablet */
.bp6-numeric-input .bp6-button[aria-label="increment"] {
    margin-top: 1px;
}

/*MOBILE PHONE SPECIFICS*/
@media only screen and (max-width: 500px) {
    /** Global search bar acts incorrectly so this fixes and centers it */
     .global-search {
        left: unset;
        width: -webkit-fill-available;
        margin: 10px;
     }

     /* Drawer */
    .bp6-drawer,
    .bp6-drawer-container {
        border-radius: 0;
    }

    .mobile-hide-scrollbar {
        scrollbar-width: none !important;
    }
}

/*TABLET SPECIFICS (ONLY SUPPORTS 1 MODEL WIDTH SIZE)*/

@media only screen and (width: 1280px) {

         /* Drawer */
    .bp6-drawer,
    .bp6-drawer-container {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .tablet-hide-scrollbar {
        scrollbar-width: none !important;
    }
}
